import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { photos } from '../../data/site';
import { ButtonLink } from '../ui/ButtonLink';
import { Container } from '../ui/Container';
import { InquiryForm } from '../forms/InquiryForm';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const reduce = useReducedMotion();
  const enter = (delay: number) => reduce ? {} : {
    initial: {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease,
      delay
    }
  };
  return <section id="top" aria-labelledby="hero-title" className="bates-hero on-dark relative isolate overflow-hidden bg-ink text-white" data-id="element-190" data-mp="q42mg7kfhi8">
      <img src={photos.clubGroup} alt="A large group of children, teens and adults together at Bates Taekwondo" className="bates-hero-photo absolute inset-0 hidden w-full lg:block" fetchPriority="high" data-id="element-191" data-mp="3rxys4q8dxzmf" />
      <div className="bates-hero-shade absolute inset-0 hidden lg:block" aria-hidden="true" data-id="element-192" data-mp="1q3heqrlx69tw" />
      <Container className="relative z-10 grid items-center gap-9 py-10 text-center sm:py-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,440px)] lg:gap-12 lg:py-10 lg:text-left" data-id="element-193" data-mp="1myp31f4vd5pz">
        <div className="mx-auto min-w-0 max-w-[980px] lg:mx-0 lg:max-w-[540px]" data-id="element-194" data-mp="1czpt7t8db41e">
          <motion.p {...enter(0)} className="font-display text-[15px] font-semibold uppercase tracking-[0.18em] text-white/90" data-id="element-195" data-mp="1hyarvo7z1fnq">
            Taekwondo in Albuquerque
          </motion.p>
          <motion.h1 {...enter(0.05)} id="hero-title" className="text-balance mt-4 font-display text-[3.15rem] font-bold uppercase leading-[0.94] tracking-[-0.01em] sm:text-[4.25rem] lg:mt-3 lg:text-[3.6rem]" data-id="element-196" data-mp="2am6oksxjj7ki">
            Big confidence starts with <span className="text-[#FF6268]" data-id="element-197" data-mp="2ol6bnw5eneek">one small step.</span>
          </motion.h1>
          <motion.p {...enter(0.1)} className="text-pretty mx-auto mt-5 max-w-[900px] text-[1.025rem] leading-relaxed text-white/90 sm:text-lg lg:mx-0 lg:mt-4 lg:max-w-[500px] lg:text-base" data-id="element-198" data-mp="2tceo71217fvy">
            At Bates Taekwondo, children, teens and adults get personal coaching, positive challenges they can actually
            meet, and a place where they belong. Come try a class and see how it feels.
          </motion.p>
          <motion.div {...enter(0.15)} className="mt-7 flex flex-col justify-center gap-3 sm:flex-row sm:flex-wrap lg:mt-5 lg:justify-start" data-id="element-199" data-mp="2p9f3o4tyzx1r">
            <ButtonLink href="#first-class" data-id="element-200" data-mp="2kau3u6imrfdu">Book a Free Trial Class</ButtonLink>
            <ButtonLink href="#programs" variant="outlineLight" className="bg-black/60" icon={<ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-202" data-mp="2aiy64wkghra5" />} data-id="element-201" data-mp="2fi0yphj92518">
              Explore Programs
            </ButtonLink>
          </motion.div>
        </div>
        <div className="-mx-5 sm:-mx-8 lg:hidden" data-id="element-203" data-mp="21j1kz4x9zaju">
          <img src={photos.clubGroup} alt="Children, teens and adults together at Bates Taekwondo" className="h-auto w-full" data-id="element-204" data-mp="21hq72ca48mf0" />
        </div>
        <div id="hero-inquiry" className="mx-auto w-full min-w-0 max-w-[440px] scroll-mt-28 text-left lg:ml-auto lg:mr-0" data-id="element-205" data-mp="1wmav5pvo50l8">
          <InquiryForm context="Home" data-id="element-206" data-mp="h0hbfnmtpbbx" />
        </div>
      </Container>
    </section>;
}